<template>
  <div>
    <Icon type="md-share" style="font-size:60px" v-if="isEditing" />
  </div>
</template>
<script>
import ajax from "@/runtime-components/lib/ajax";
import { loadJs } from "@/runtime-components/lib/utils.js";
export default {
  props: ["title", "desc", "link", "imgUrl", "isEditing", "isDebug"],
  created() {
    loadJs("http://res.wx.qq.com/open/js/jweixin-1.6.0.js", () => {
      this.getAuth().then((authInfo) => {
        wx.config({
          debug: !!this.isDebug,
          appId: authInfo.appId,
          timestamp: authInfo.timestamp,
          nonceStr: authInfo.nonceStr,
          signature: authInfo.signature,
          jsApiList: ["updateAppMessageShareData", "updateTimelineShareData", "checkJsApi","onMenuShareTimeline","onMenuShareAppMessage","onMenuShareQQ","onMenuShareWeibo","onMenuShareQZone","hideMenuItems","showMenuItems","hideAllNonBaseMenuItem","showAllNonBaseMenuItem","translateVoice","startRecord","stopRecord","onVoiceRecordEnd","playVoice","onVoicePlayEnd","pauseVoice","stopVoice","uploadVoice","downloadVoice","chooseImage","previewImage","uploadImage","downloadImage","getNetworkType","openLocation","getLocation","hideOptionMenu","showOptionMenu","closeWindow","scanQRCode","chooseWXPay","openProductSpecificView","addCard","chooseCard","openCard"] // 必填，需要使用的JS接口列表
        });

        wx.ready(()=>{
          //需在用户可能点击分享按钮前就先调用
          wx.onMenuShareAppMessage({
            title: this.title,
            desc: this.desc,
            link: this.link,
            imgUrl: this.imgUrl,
            success: function() {
              console.log('share success');
            }
          });

          wx.onMenuShareTimeline({
                title: this.title,
                link: this.link,
                imgUrl: this.imgUrl,
                success: function () {
                    console.log('share success');
                }
            });

            wx.onMenuShareQQ({
                title: this.title,
                desc: this.desc,
                link: this.link,
                imgUrl: this.imgUrl,
                success: function () {
                console.log('share success');
                },
                cancel: function () {
                console.log('share cancel');
                }
            });

            wx.onMenuShareWeibo({
                title: this.title,
                desc: this.desc,
                link: this.link,
                imgUrl: this.imgUrl,
                success: function () {
                console.log('share success');
                },
                cancel: function () {
                console.log('share success');
                }
            });
        });
      });
    });
  },

  methods: {
    getAuth() {
      return ajax.get("/api/weixin/config", {
        params: { url: location.href }
      });
    }
  }
};
</script>